import { PostHogEventEnum } from '@/lib/enum/PostHogEventEnum';
import { isTruthy } from '@/lib/helpers/booleans';
import postHog from 'posthog-js';

export const postHogInitialised = (): boolean => {
  return !!postHog && typeof postHog.capture === 'function' && postHog.__loaded;
};

export const setPostHogConsent = (consent: boolean) => {
  if (postHogInitialised()) {
    if (consent) {
      postHog.opt_in_capturing();
    } else {
      postHog.opt_out_capturing();
    }
  }
};

export const postHogCapture = (key: PostHogEventEnum, value: object): void => {
  if (postHogInitialised()) {
    postHog.capture(key, value);
  }
};

export function usePostHog() {
  if (isTruthy(process.env.VUE_APP_POST_HOG_ENABLED) && !postHogInitialised()) {
    postHog.init(process.env.VUE_APP_POST_HOG_TOKEN, {
      api_host: 'https://eu.i.posthog.com',
      defaults: '2025-11-30',
      person_profiles: 'identified_only',
    });
    setPostHogConsent(true);
  }

  return { postHog };
}
